import {connect} from 'react-redux';
import type {Dispatch, ActionCreatorsMapObject} from 'redux';
import {bindActionCreators} from 'redux';

import {getConfig, getLicense} from 'mattermost-redux/selectors/entities/general';
import {getCurrentUser} from 'mattermost-redux/selectors/entities/users';
import type {GlobalState} from 'mattermost-redux/types/store';
import type {ActionFunc} from 'mattermost-redux/types/actions';

import {deactivateMfa} from 'actions/views/mfa';
import Constants from 'utils/constants';

import MfaSection from './mfa_section';

type Actions = {
    deactivateMfa: () => Promise<{error?: {message: string}}>;
}

function mapStateToProps(state: GlobalState) {
    const license = getLicense(state);
    const config = getConfig(state);
    const user = getCurrentUser(state);

    const mfaLicensed = license && license.IsLicensed === 'true' && license.MFA === 'true';
    const isSMSAuthUsed = config.MultifactorAuthenticationType?.toLowerCase() === 'sms';

    let mfaAvailable = false;
    let mfaEnforced = false;

    if (user) {
        const isAnyGuest = user.isGuestPlus || user.isGuest;
        const mfaEnabled = isAnyGuest ? config.GuestAccountsEnableMultifactorAuthentication === 'true' : config.EnableMultifactorAuthentication === 'true';
        mfaEnforced = mfaLicensed && (isAnyGuest ? config.GuestAccountsEnforceMultifactorAuthentication === 'true' : config.EnforceMultifactorAuthentication === 'true');
        mfaAvailable = mfaEnabled && (user.auth_service === '' || user.auth_service === Constants.LDAP_SERVICE) && !isSMSAuthUsed;
    }
    return {
        mfaActive: user?.mfa_active ?? false,
        mfaAvailable,
        mfaEnforced,
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject<ActionFunc>, Actions>({
            deactivateMfa,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MfaSection);
